import React from "react";

// Covers every Status value across the Stock module. LPO and Stock
// Adjustment have real approval workflows (SUBMITTED/APPROVED/REJECTED/...);
// Stock-In and Stock Return are always POSTED and Stock-Out is always ISSUED
// (confirmed in Batch42_StockManagement.sql - none of the three have a
// lifecycle at all, they're immutable once created) - those two badges are
// shown purely for visual consistency with the other lists, not because the
// value ever varies.
const CLASS_BY_STATUS = {
  SUBMITTED: "badge-linewarning",
  REVISED_SUBMITTED: "badge-linewarning",
  APPROVED: "badge-linesuccess",
  PARTIALLY_RECEIVED: "badge-lineinfo",
  FULLY_RECEIVED: "badge-linesuccess",
  POSTED: "badge-linesuccess",
  ISSUED: "badge-linesuccess",
  REJECTED: "badge-linedanger",
  CANCELLED: "badge-linedanger",
};

const LABEL_BY_STATUS = {
  SUBMITTED: "Submitted",
  REVISED_SUBMITTED: "Revised - Submitted",
  APPROVED: "Approved",
  PARTIALLY_RECEIVED: "Partially Received",
  FULLY_RECEIVED: "Fully Received",
  POSTED: "Posted",
  ISSUED: "Issued",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};

const StatusBadge = ({ status }) => (
  <span className={`badge ${CLASS_BY_STATUS[status] || "badge-linesecondary"}`}>
    {LABEL_BY_STATUS[status] || status}
  </span>
);

export default StatusBadge;
